import { Link, Outlet } from "react-router-dom"
import { FileText, ShieldCheck } from "lucide-react"

import { AuthorFooter } from "@/app/layouts/AuthorFooter"
import { ThemeToggle } from "@/app/layouts/header-actions"
import { LogoInstitucional } from "@/modules/cadastro/components/LogoInstitucional"
import { useInstitucionalPublico } from "@/modules/cadastro/hooks/useInstitucionalPublico"

/**
 * Layout das páginas públicas (Política de Privacidade / Termos de Uso).
 * Fora do AuthGuard e do AppLayout — acessível sem sessão.
 */
export function PublicLayout() {
  const { data: institucional } = useInstitucionalPublico()
  const nome = institucional?.nomeEmpresa?.trim() || "SIGI"
  const sigla = institucional?.sigla?.trim()

  return (
    <div className="flex min-h-svh flex-col bg-background">
      <header className="border-b bg-card/60">
        <div className="mx-auto flex w-full max-w-4xl items-center justify-between gap-4 px-4 py-3 sm:px-6">
          <div className="flex items-center gap-3">
            <LogoInstitucional
              className="h-9 w-auto max-w-[180px] object-contain"
              fallback={
                <div className="flex items-center gap-2.5">
                  <div className="flex size-9 items-center justify-center rounded-lg bg-primary font-bold text-primary-foreground">
                    S
                  </div>
                  <div>
                    <p className="font-semibold text-sm leading-tight">SIGI</p>
                    <p className="text-muted-foreground text-xs">
                      {sigla ?? "Gestão Interna"}
                    </p>
                  </div>
                </div>
              }
            />
          </div>

          <nav className="flex flex-wrap items-center justify-end gap-1 text-sm">
            <Link
              to="/formularios-publicos"
              className="rounded-md px-3 py-1.5 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
            >
              Formulários
            </Link>
            <Link
              to="/acompanhar"
              className="rounded-md px-3 py-1.5 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
            >
              Acompanhar
            </Link>
            <Link
              to="/termos"
              className="rounded-md px-3 py-1.5 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
            >
              Termos de Uso
            </Link>
            <Link
              to="/privacidade"
              className="rounded-md px-3 py-1.5 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
            >
              Privacidade
            </Link>
            <ThemeToggle />
          </nav>
        </div>
      </header>

      <main className="mx-auto w-full max-w-4xl flex-1 px-4 py-10 sm:px-6">
        <Outlet />
      </main>

      <footer className="border-t bg-muted/30">
        <div className="mx-auto flex w-full max-w-4xl flex-wrap items-center justify-center gap-x-4 gap-y-1 px-4 py-2 text-center text-xs text-muted-foreground sm:px-6">
          <p>
            &copy; {new Date().getFullYear()} {nome}
            {sigla ? ` · ${sigla}` : ""}
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
            <Link to="/privacidade" className="inline-flex items-center gap-1.5 hover:text-foreground">
              <ShieldCheck className="size-3.5" />
              Política de Privacidade
            </Link>
            <Link to="/termos" className="inline-flex items-center gap-1.5 hover:text-foreground">
              <FileText className="size-3.5" />
              Termos de Uso
            </Link>
            <AuthorFooter />
          </div>
        </div>
      </footer>
    </div>
  )
}
